<div ngbDropdown
     [autoClose]="'outside'"
     [placement]="'bottom-left'"
     #checkDeliveryDropdown="ngbDropdown">
  <button
    ngbDropdownToggle
    id="checkDeliveryDropdown"
    class="btn btn-slim btn-shadow-primary dropdown-toggle no-toggle-styles">
    <i class="icon-truck-delivery font-xl me-2 d-inline-block text-primary"></i>
    <span [translate]="'orderProcess.cakesOverview.searchCakesPanel.deliveryInfo'">Delivery to door?</span>
  </button>
  <div class="pt-3 px-4 px-md-max-3 pb-4"
       ngbDropdownMenu
       aria-labelledby="checkDeliveryDropdown">
    <post-number-delivery-check
      [cityName]="cityName"
      [countryCode]="countryCode"
      [postNumberChecker]="postNumberChecker.bind(this)"
      (onCityChosen)="onDifferentLocationFound.emit($event); checkDeliveryDropdown.close();"
      (onPostNumberChosen)="onPostNumberChosen.emit($event); checkDeliveryDropdown.close();">
    </post-number-delivery-check>
  </div>
</div>
